import { render, staticRenderFns } from "./ErpMoneyBank.vue?vue&type=template&id=7faef01a&"
import script from "./ErpMoneyBank.vue?vue&type=script&lang=js&"
export * from "./ErpMoneyBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports